<style lang="scss" scoped>
.product-input-form {
  background: #eee;
  padding: 10px;

  h2 {
    font-size: 14px;
    margin: 0 0 10px;
  }
}
.product-container {
  display: flex;
  padding: 10px;
  border: 1px solid #eee;
}
.product-thumbnail {
  width: 140px;
}
.product-content {
  flex: 1;
  margin: 0 0 0 10px;
  position: relative;
  padding: 0 0 50px;
}
.product-title {
  color: #e47911;
  margin: 0 0 7px;
  font-size: 1.6rem;
  line-height: 2.4rem;
  font-weight: bold;
}
.product-price {
  list-style: none;
  line-height: 1.7rem;
  font-size: 1.2rem;
  margin: 0;
  padding: 0;

  .num {
    color: #900;
  }
}
.product-info {
  list-style: none;
  line-height: 1.7rem;
  font-size: 1.2rem;
  margin: 0;
  padding: 0;
}
.amazon-button {
  display: block;
  position: absolute;
  width: 100%;
  bottom: 0;
}
.amazon-button-link {
  background: #f6ce50;
  color: #000;
  font-size: 14px;
  text-decoration: none;
  padding: 7px 15px 5px;
  border-radius: 5px;
  border-bottom: 3px solid #e3b628;
  margin-top: 10px;
  width: auto;
  text-align: center;
  display: block;
  font-weight: 700;
  line-height: 2em;
  &:hover {
    background-color: #ffe38e;
  }
}
</style>

<template>
  <div class="product-input">
    <div class="product-input-form" v-if="isEditing">
      <h2>商品</h2>
      <div class="form-group">
        <label for="" class="form-label">タイプ</label>
        <select v-model="type" disabled>
          <option value="amazon" selected>Amazon</option>
        </select>
      </div>
      <div class="form-group">
        <label for="" class="form-label">URL</label>
        <input v-model="url" type="text" class="form-control" />
        <a @click="check()" class="btn-green">チェック</a>
      </div>
      <div class="form-group">
        <label for="" class="form-label">価格</label>
        <input type="text" class="form-control" v-model="price" />
      </div>
      <div class="form-group">
        <label for="" class="form-label">画像</label>
        <img
          v-if="image_url && image_url.length"
          :src="image_url"
          class="img-responsive"
          width="100px"
        />
      </div>
      <div class="form-group">
        <label for="" class="form-label">商品名</label>
        <input type="text" class="form-control" v-model="title" />
      </div>
      <div class="form-group">
        <label for="" class="form-label">説明</label>
        <textarea cols="3" class="form-control" v-model="info"></textarea>
      </div>
      <div class="form-group">
        <div class="btn-group">
          <a @click="onEndEdit()" class="btn-green">追加</a>
          <a class="btn-normal" @click="onDeleteInput()">削除</a>
        </div>
      </div>
    </div>
    <div class="product-input-preview input-preview" v-else>
      <div class="product-container">
        <div class="product-thumbnail">
          <img v-if="image_url" :src="image_url" class="img-responsive" />
        </div>
        <div class="product-content">
          <div class="product-title">{{ title }}</div>
          <div class="product-price">
            価格
            <span class="num">{{ price }}</span>
          </div>
          <div class="product-info">{{ info }}</div>
          <div class="amazon-button">
            <a
              :href="amazonURL"
              class="amazon-button-link"
              rel="nofollow"
              target="_blank"
            >
              <i class="fa fa-amazon"></i>
              クリックして今すぐチェック
            </a>
          </div>
        </div>
      </div>
      <footer-menu
        :onBeginEdit="onBeginEdit"
        :onDeleteInput="onDeleteInput"
        :onPullUp="onPullUp"
        :onPullDown="onPullDown"
        :index="index"
      />
    </div>
  </div>
</template>

<script>
import footerMenu from './input-footer-menu.vue';
export default {
  data() {
    return {
      isEditing: false,
      url: '',
      type: 'amazon',
      title: '',
      image_url: '',
      amazon_id: '',
      price: '',
      info: '',
    };
  },
  mounted() {
    this.url = this.value.url;
    this.image_url = this.value.image_url;
    this.price = this.value.price;
    this.title = this.value.title;
    this.amazon_id = this.value.amazon_id;
    this.info = this.value.info;
  },
  computed: {
    bodyJSON() {
      return {
        value: {
          url: this.url,
          type: this.type,
          title: this.title,
          image_url: this.image_url,
          amazon_id: this.amazon_id,
          price: this.price,
          info: this.info,
        },
        action: 'product',
      };
    },
    valid() {
      return this.url && this.url.length && this.title && this.title.length;
    },
    amazonURL() {
      return `https://amazon.jp/dp/${this.amazon_id}?tag=${FS.amazon_associate_tag}`;
    },
  },
  props: {
    index: Number,
    value: {},
    id: String,
  },
  components: {
    'footer-menu': footerMenu,
  },
  methods: {
    check() {
      $.get({
        url: '/api/amazon',
        data: {
          url: this.url,
        },
      })
        .then((response) => {
          this.title = response.title;
          this.amazon_id = response.amazon_id;
          this.price = response.price;
          this.image_url = response.image_url;
        })
        .catch((e) => {
          console.error(e);
        });
    },
    onBeginEdit() {
      this.isEditing = true;
    },
    onEndEdit() {
      if (!this.valid) {
        const alertArray = [];
        if (!this.url || !this.url.length) {
          alertArray.push('商品URLを入力してください。');
        }
        if (!this.title || !this.title.length) {
          alertArray.push('商品名を入力してください。');
        }
        if (!this.amazon_id || !this.amazon_id.length) {
          alertArray.push('amazon IDが不明です');
        }
        alert(alertArray.join('\n'));
        return false;
      }
      this.isEditing = false;
    },
    onDeleteInput() {
      bus.$emit('delete-input', this.index);
    },
    onPullUp() {
      bus.$emit('pull-up-item', this.index);
    },
    onPullDown() {
      bus.$emit('pull-down-item', this.index);
    },
  },
};
</script>
